import { render, staticRenderFns } from "./concernedContactBox.vue?vue&type=template&id=ee3822a2"
import script from "./concernedContactBox.vue?vue&type=script&lang=js"
export * from "./concernedContactBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports